import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subtract',
  templateUrl: './subtract.component.html',
  styleUrls: ['./subtract.component.css']
})
export class SubtractComponent implements OnInit {
  title = 'Øv dig i at trække tal fra hinanden';
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/subtract/subtract.component.ts